import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { requiredPayloadEnvelope } from '../envelope.js';
const c = initContract();
/** user-api GIF 변환 요청 스텁 — 서버 변환 파이프라인 구현 전 자리만 유지한다. */
export const userConvertContract = c.router({
    /** 변환 작업을 접수한다. 현재는 202와 TODO 메시지만 반환한다. */
    request: {
        method: 'POST',
        path: '/convert',
        body: z.unknown().optional(),
        responses: {
            202: requiredPayloadEnvelope(z.unknown()),
        },
    },
    /** 변환 작업 상태를 조회한다. 현재는 항상 `pending` 스텁이다. */
    getStatus: {
        method: 'GET',
        path: '/convert/:jobId',
        pathParams: z.object({
            /** 조회할 변환 작업 id다. */
            jobId: z.string(),
        }),
        responses: {
            200: requiredPayloadEnvelope(z.object({
                /** 요청한 작업 id다. */
                jobId: z.string(),
                /** 작업 상태 문자열이다. 구현 전에는 `pending` 고정이다. */
                status: z.string(),
                /** 운영자·클라이언트용 부가 메시지다. */
                message: z.string().optional(),
            })),
        },
    },
});
//# sourceMappingURL=convert.contract.js.map